import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import Logo from "./Logo";

export default function LegalHeader() {
  return (
    <header
      data-testid="legal-header"
      className="sticky top-0 z-50 bg-white border-b border-[#E5E5E5]"
    >
      <div className="max-w-[1200px] mx-auto px-6 md:px-8 h-16 md:h-20 flex items-center justify-between">
        <Logo size="text-xl md:text-2xl" />
        <Link
          data-testid="legal-back-home"
          to="/"
          className="inline-flex items-center gap-2 text-[15px] font-medium text-[#0A0A0A] hover:text-[#B40101] transition-colors duration-200"
        >
          <ArrowLeft className="w-4 h-4" /> Torna alla home
        </Link>
      </div>
    </header>
  );
}
